
import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import Index from '@/pages/Index';
import Contact from '@/pages/Contact';
import NotFound from '@/pages/NotFound';
import Collab from '@/pages/Collab';
import SaasDevelopment from '@/pages/SaasDevelopment';
import MobileAppDevelopment from '@/pages/MobileAppDevelopment';
import MarketplaceDevelopment from '@/pages/MarketplaceDevelopment';
import AutomationDevelopment from '@/pages/AutomationDevelopment';
import Projects from '@/pages/Projects';
import MentionsLegales from '@/pages/MentionsLegales';
import TermesConditions from '@/pages/TermesConditions';
import Confidentialite from '@/pages/Confidentialite';
import MaintenanceSupport from '@/pages/MaintenanceSupport';
import WebDevelopment from '@/pages/WebDevelopment';
import About from '@/pages/About';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import IdeaFactory from '@/pages/IdeaFactory';
import Booking from '@/pages/Booking';
import EngagementEnvironnemental from '@/pages/EngagementEnvironnemental';
import Partenaires from '@/pages/Partenaires';
import PrototypeDevelopment from '@/pages/PrototypeDevelopment';
import DemoLogin from '@/pages/DemoLogin';
import EstimationPage from '@/pages/EstimationPage';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Index />,
      },
      {
        path: '/projets',
        element: <Projects />,
      },
      {
        path: '/projects',
        element: <Projects />,
      },
      {
        path: '/contact',
        element: <Contact />,
      },
      {
        path: '/partenaires',
        element: <Partenaires />,
      },
      {
        path: '/collab',
        element: <Collab />,
      },
      {
        path: '/booking',
        element: <Booking />,
      },
      {
        path: '/engagement-environnemental',
        element: <EngagementEnvironnemental />,
      },
      {
        path: '/developpement-saas',
        element: <SaasDevelopment />,
      },
      {
        path: '/developpement-mobile',
        element: <MobileAppDevelopment />,
      },
      {
        path: '/developpement-marketplace',
        element: <MarketplaceDevelopment />,
      },
      {
        path: '/ia-automatisation',
        element: <AutomationDevelopment />,
      },
      {
        path: '/maintenance-support',
        element: <MaintenanceSupport />,
      },
      {
        path: '/developpement-web',
        element: <WebDevelopment />,
      },
      {
        path: '/prototype',
        element: <PrototypeDevelopment />,
      },
      {
        path: '/demo-login',
        element: <DemoLogin />,
      },
      {
        path: '/estimation',
        element: <EstimationPage />,
      },
      {
        path: '/a-propos',
        element: <About />,
      },
      {
        path: '/blog',
        element: <Blog />,
      },
      {
        path: '/blog/comment-construire-une-startup-tech-qui-dure',
        element: <BlogPost />,
      },
      {
        path: '/idea-factory',
        element: <IdeaFactory />,
      },
      {
        path: '/mentions-legales',
        element: <MentionsLegales />,
      },
      {
        path: '/termes-et-conditions',
        element: <TermesConditions />,
      },
      {
        path: '/confidentialite',
        element: <Confidentialite />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
